import { FigmaTypography } from "@libs/zapi-ui/custom";
import { Spinner } from "@libs/zapi-ui/ds/components/spinner";
import { useTranslation } from "react-i18next";
import { InitialHeader } from "./_InitialHeader";

export function LoadingWidget() {
  const { t } = useTranslation();
  return (
    <div className="h-full flex flex-col grow overflow-y-auto" data-testid="claims-root">
      <InitialHeader />
      <div className="h-full flex flex-col p-2 gap-2 items-center justify-center bg-innoveraZinc-100 rounded-b-[8px]">
        <Spinner aria-label={t("loading")} className="size-5 text-muted-foreground" />
        <FigmaTypography variant="body-3" color="zinc500" className="text-center font-light">
          Loading claims...
        </FigmaTypography>
      </div>
    </div>
  );
}
